import React, { useMemo } from 'react';
import { apiHolder, apis, NoSetDeferTime, approvalStatusMap, } from 'api';
import { Tooltip, Popover, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { formatDigitalTime, dateFormat, formatTimeWithHM, formatTimeWithHMSimple, transTag2Name, escapeHtmlExceptB, } from '../../../../util';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import ReceiverAvatar from '@/images/mail/receiver_avatar.svg';
import MailTag from '../../MailTag/MailTag';
import cloneDeep from 'lodash/cloneDeep';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import CustomerLabel from '@web-mail/components/ReadMail/component/CustomerLabel';
import RevokeCountDown from '@web-mail/components/RevokeCountDown/RevokeCountDown';
import { useAppSelector } from '@web-common/state/createStore';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import PersonalMark from '@web-common/components/UI/SiriusContact/personalMark/mark';
import { useContactModel, useContactModelNames, useContactModelList } from '@web-common/hooks/useContactModel';
import { getIn18Text } from 'api';
import IconCard from '@web-common/components/UI/IconCard';
import moment from 'moment';
import { debounce } from 'lodash';
import { ReactComponent as QyTag } from '@/images/icons/mail/qyTag.svg';
import { FLOLDER } from '@web-mail/common/constant';
import { isInboxLikeFolder } from '@web-mail/utils/folder';
import { copyText } from '@web-common/components/UI/ContextMenu/util';
import useMailTabCompanyStr from '@web-mail/hooks/useMailTabCompanyStr';
import ReadStatus from '@web-mail/components/StatusModal/listPopover';
import OpenRecordsContent from '@web-mail/components/OpenRecordsList/OpenRecordsContent';
import { isThirdSendFn } from '@web-mail/components/OpenRecords/OpenRecords';
import { tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
const mailManagerApi = apiHolder.api.requireLogicalApi('mailConfApiImpl');
const systemApi = apiHolder.api.getSystemApi();
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const storeApi = apiHolder.api.getDataStoreApi();
export const renderContacts = (item, config) => {
    var _a, _b;
    const { isThread: isMerging = false, _account } = item || {};
    const { extraData, model: storeContact, nameMap, isSender, preCompanyNames = '' } = config || {};
    const titleArray = [];
    const inSenderFolder = item.entry.folder === 2 || item.entry.folder === 3;
    const showSender = isSender || inSenderFolder || extraData === 'localDraft';
    const set = new Set();
    function addItem(citem, findNameFromRedux = false) {
        var _a, _b, _c, _d;
        if (((_a = citem === null || citem === void 0 ? void 0 : citem.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) && !set.has((_b = citem === null || citem === void 0 ? void 0 : citem.contactItem) === null || _b === void 0 ? void 0 : _b.contactItemVal)) {
            const _contact = (_c = citem === null || citem === void 0 ? void 0 : citem.contact) === null || _c === void 0 ? void 0 : _c.contact;
            if (!_contact) {
                return;
            }
            const email = contactApi.doGetModelDisplayEmail(citem === null || citem === void 0 ? void 0 : citem.contact);
            let name = '';
            if (findNameFromRedux && nameMap && Reflect.has(nameMap, email)) {
                name = nameMap[email];
            }
            else {
                name = (_contact === null || _contact === void 0 ? void 0 : _contact.type) !== 'external' && _contact.contactName ? _contact.contactName : citem.originName || _contact.contactName;
            }
            titleArray.push(_account === email ? getIn18Text('WO') : name);
            set.add((_d = citem === null || citem === void 0 ? void 0 : citem.contactItem) === null || _d === void 0 ? void 0 : _d.contactItemVal);
        }
    }
    function addItemByStoreContact(citem, storeItem) {
        var _a, _b;
        if (((_a = citem === null || citem === void 0 ? void 0 : citem.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) && !set.has(citem.contactItem.contactItemVal)) {
            const _contact = storeItem.contact;
            if (_contact) {
                const email = contactApi.doGetModelDisplayEmail(storeItem === null || storeItem === void 0 ? void 0 : storeItem.contact);
                const name = (_contact === null || _contact === void 0 ? void 0 : _contact.type) !== 'external' && _contact.contactName ? _contact.contactName : (citem === null || citem === void 0 ? void 0 : citem.originName) || (_contact === null || _contact === void 0 ? void 0 : _contact.contactName);
                titleArray.push(_account === email ? getIn18Text('WO') : name);
                set.add((_b = citem === null || citem === void 0 ? void 0 : citem.contactItem) === null || _b === void 0 ? void 0 : _b.contactItemVal);
            }
        }
    }
    if (showSender) {
        if (item.receiver && item.receiver.length > 0) {
            item.receiver.forEach(it => {
                addItem(it, true);
            });
        }
    }
    else if (item.senders && item.senders.length > 0) {
        if (item.senders.length == 1) {
            if (storeContact) {
                addItemByStoreContact(((_a = item === null || item === void 0 ? void 0 : item.senders[0]) === null || _a === void 0 ? void 0 : _a.originName) === '无发件人' ? item === null || item === void 0 ? void 0 : item.sender : item === null || item === void 0 ? void 0 : item.senders[0], storeContact);
            }
            else {
                addItem(((_b = item === null || item === void 0 ? void 0 : item.senders[0]) === null || _b === void 0 ? void 0 : _b.originName) === '无发件人' ? item === null || item === void 0 ? void 0 : item.sender : item === null || item === void 0 ? void 0 : item.senders[0]);
            }
        }
        else {
            item.senders.forEach(it => {
                addItem(it, true);
            });
        }
    }
    else {
        if (storeContact) {
            addItemByStoreContact(item === null || item === void 0 ? void 0 : item.sender, storeContact);
        }
        else {
            addItem(item === null || item === void 0 ? void 0 : item.sender);
        }
    }
    return (showSender && !isMerging ? getIn18Text('ZHI\uFF1A') : '') + preCompanyNames + titleArray.join('、');
};
const ReceiverContact = props => {
    var _a;
    const { citem, findNameFromRedux, storeItem, nameMap, _account, item } = props;
    const contact = (storeItem === null || storeItem === void 0 ? void 0 : storeItem.contact) || ((_a = citem === null || citem === void 0 ? void 0 : citem.contact) === null || _a === void 0 ? void 0 : _a.contact);
    const receivemodel = useContactModel({
        contactId: contact === null || contact === void 0 ? void 0 : contact.id,
        email: contactApi.doGetModelDisplayEmail(citem === null || citem === void 0 ? void 0 : citem.contact),
        name: contact.contactName,
    });
    const preCompanyNames = useMailTabCompanyStr(receivemodel, item === null || item === void 0 ? void 0 : item._account, true) || '';
    const email = contactApi.doGetModelDisplayEmail(citem === null || citem === void 0 ? void 0 : citem.contact);
    let name = '';
    if (!contact)
        return null;
    if (findNameFromRedux && nameMap && Reflect.has(nameMap, email)) {
        name = nameMap[email];
    }
    else {
        name = (contact === null || contact === void 0 ? void 0 : contact.type) !== 'external' && contact.contactName ? contact.contactName : citem.originName || contact.contactName;
    }
    return React.createElement(React.Fragment, null, _account === email ? getIn18Text('WO') : preCompanyNames ? preCompanyNames + name : name);
};
export const useRenderReceiverContacts = (item, config) => {
    var _a, _b;
    const { isThread: isMerging = false, _account } = item || {};
    const { extraData, nameMap, isSender } = config || {};
    const titleArray = [];
    const inSenderFolder = ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.folder) === 2 || ((_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.folder) === 3;
    const showSender = isSender || inSenderFolder || extraData === 'localDraft';
    const set = new Set();
    const contactData = [];
    function collectContactData(citem, findNameFromRedux = false, storeItem) {
        var _a, _b, _c;
        if (((_a = citem === null || citem === void 0 ? void 0 : citem.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) && !set.has((_b = citem === null || citem === void 0 ? void 0 : citem.contactItem) === null || _b === void 0 ? void 0 : _b.contactItemVal)) {
            contactData.push({ citem, findNameFromRedux, storeItem });
            set.add((_c = citem === null || citem === void 0 ? void 0 : citem.contactItem) === null || _c === void 0 ? void 0 : _c.contactItemVal);
        }
    }
    if (showSender) {
        if ((item === null || item === void 0 ? void 0 : item.receiver) && item.receiver.length > 0) {
            item.receiver.forEach(it => collectContactData(it, true));
        }
        contactData.forEach(({ citem, findNameFromRedux, storeItem }) => {
            titleArray.push(React.createElement(ReceiverContact, { citem: citem, findNameFromRedux: findNameFromRedux, storeItem: storeItem, nameMap: nameMap, _account: _account, item: item }));
        });
        return (React.createElement(React.Fragment, null,
            showSender && !isMerging ? getIn18Text('ZHI\uFF1A') : '',
            titleArray.map((item, index) => {
                return (React.createElement(React.Fragment, null,
                    item,
                    index != titleArray.length - 1 ? '、' : ''));
            })));
    }
    return React.createElement(React.Fragment, null);
};
export const defaultComAvatar = (props) => {
    var _a, _b;
    const { data, size = 32 } = props;
    const senderContact = (_b = (_a = data === null || data === void 0 ? void 0 : data.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact;
    const { id, contactName, color } = senderContact || {};
    const email = contactApi.doGetModelDisplayEmail(senderContact);
    return (React.createElement(AvatarTag, { className: "avatar-item", size: size, contactId: id, propEmail: email, user: {
            avatar: senderContact === null || senderContact === void 0 ? void 0 : senderContact.avatar,
            name: contactName,
            color,
            email,
        } }));
};
export const receiverComAvatar = (props) => {
    var _a, _b, _c, _d;
    const { sendingMails } = useAppSelector(state => state.mailReducer);
    const { data, size = 32 } = props;
    const { entry } = data;
    const { id } = entry;
    const sendingMail = sendingMails.find(item => item.id === id);
    let defaultReceiver = data.receiver[0];
    let contactId;
    let email;
    const receiverContact = (_a = defaultReceiver === null || defaultReceiver === void 0 ? void 0 : defaultReceiver.contact) === null || _a === void 0 ? void 0 : _a.contact;
    if (receiverContact) {
        contactId = receiverContact.id;
        email = contactApi.doGetModelDisplayEmail(receiverContact);
    }
    return (React.createElement(AvatarTag, { className: "avatar-item", size: size, contactId: contactId, propEmail: email, user: {
            avatar: ((_b = data === null || data === void 0 ? void 0 : data.receiver) === null || _b === void 0 ? void 0 : _b.length) > 1 ? ReceiverAvatar : (_d = (_c = defaultReceiver === null || defaultReceiver === void 0 ? void 0 : defaultReceiver.contact) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.avatar,
            name: receiverContact === null || receiverContact === void 0 ? void 0 : receiverContact.contactName,
            color: receiverContact === null || receiverContact === void 0 ? void 0 : receiverContact.color,
            email,
        } }, sendingMail && (React.createElement(RevokeCountDown, { id: id, createTime: sendingMail.createTime, attrs: {
            strokeColor: '#94A6FF',
            strokeLinecap: 'butt',
            trailColor: 'rgba(0, 0, 0, 0.5)',
            strokeWidth: 7.5,
            width: 32,
        }, leftSecStyle: {
            width: '27px',
            height: '27px',
            fontWeight: 400,
            fontSize: '12px',
            color: 'white',
            background: 'rgba(0, 0, 0, 0.5)',
            lineHeight: '27px',
            display: 'block',
            borderRadius: '999px',
            overflow: 'hidden',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
        } }))));
};
export const defaultDesc = (props) => {
    const { data: { entry }, } = props;
    let brief = '';
    const entryBrief = entry.brief || '';
    const wuzhuti = ' ';
    const emptyBriefReg = /^\s*$/;
    if (!entryBrief || emptyBriefReg.test(entryBrief)) {
        brief = wuzhuti;
    }
    else {
        brief = entryBrief;
    }
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: brief } });
};
export const defaultDescFun = (props, contentReservable) => {
    var _a;
    const { data: { entry }, } = props;
    let brief = '';
    const entryBrief = entry.brief || '';
    const entryContent = ((_a = entry === null || entry === void 0 ? void 0 : entry.content) === null || _a === void 0 ? void 0 : _a.content) || '';
    const wuzhuti = ' ';
    const emptyBriefReg = /^\s*$/;
    if (!entryBrief || emptyBriefReg.test(entryBrief)) {
        if (contentReservable) {
            const tmpDoc = new DOMParser().parseFromString(entryContent, 'text/html');
            const tmpDocText = (tmpDoc.documentElement.innerText || '').substring(0, 30);
            if (tmpDocText) {
                brief = tmpDocText;
            }
            else {
                brief = wuzhuti;
            }
        }
        else {
            brief = wuzhuti;
        }
    }
    else {
        brief = entryBrief;
    }
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: escapeHtmlExceptB(brief) } });
};
export const defaultSender = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { data, extraData } = props;
    const email = contactApi.doGetModelDisplayEmail((_a = data === null || data === void 0 ? void 0 : data.sender) === null || _a === void 0 ? void 0 : _a.contact);
    const model = useContactModel({
        contactId: (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.sender) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.id,
        email: email,
        name: (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.sender) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.contact) === null || _g === void 0 ? void 0 : _g.contactName,
    });
    const isSender = useMemo(() => {
        var _a, _b, _c;
        if (data) {
            const accountAlias = ((_b = (_a = systemApi.getCurrentUser(data === null || data === void 0 ? void 0 : data._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
            const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
            const senderEmail = contactApi.doGetModelDisplayEmail((_c = data === null || data === void 0 ? void 0 : data.sender) === null || _c === void 0 ? void 0 : _c.contact);
            return (accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) || accountApi.getIsSameSubAccountSync(senderEmail, data._account));
        }
        else {
            return false;
        }
    }, [data]);
    const showSender = isSender || extraData === 'localDraft';
    const multipleContactModel = showSender ? data.receiver : data.senders && data.senders.length > 1 ? data.senders : [];
    const nameMap = useContactModelNames({
        emails: multipleContactModel.map(item => {
            var _a, _b;
            return (_b = (_a = item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName;
        }),
        enableQuery: showSender || (data.senders && data.senders.length > 1),
    });
    const preCompanyNames = useMailTabCompanyStr(model, data === null || data === void 0 ? void 0 : data._account, true);
    const empty = (data === null || data === void 0 ? void 0 : data.entry.folder) === 2 || (data === null || data === void 0 ? void 0 : data.entry.folder) === 3 ? getIn18Text('WUSHOUJIANREN') : getIn18Text('WUFAJIANREN');
    const receiverInfo = useRenderReceiverContacts(data, { extraData, nameMap, isSender }) || empty;
    const senderName = ((_h = model === null || model === void 0 ? void 0 : model.contact) === null || _h === void 0 ? void 0 : _h.contactName) || ((_l = (_k = (_j = data === null || data === void 0 ? void 0 : data.sender) === null || _j === void 0 ? void 0 : _j.contact) === null || _k === void 0 ? void 0 : _k.contact) === null || _l === void 0 ? void 0 : _l.contactName) || '';
    if (((_m = data === null || data === void 0 ? void 0 : data.entry) === null || _m === void 0 ? void 0 : _m.folder) != null && !isInboxLikeFolder(data.entry.folder)) {
        return React.createElement("span", null, receiverInfo);
    }
    else {
        const senderInfo = renderContacts(data, { extraData, model, nameMap, isSender, preCompanyNames }) || empty;
        const tooltipContent = (React.createElement("span", null,
            senderName && email ? `${senderName}<${email}>` : senderName || email || '',
            email ? (React.createElement(CopyOutlined, { style: { marginLeft: 8, cursor: 'pointer', fontSize: 12 }, onClick: e => {
                    e.stopPropagation();
                    copyText(email);
                    message.success(getIn18Text('YIFUZHI'));
                } })) : null));
        return (React.createElement(Tooltip, { title: tooltipContent, mouseEnterDelay: 0.5, mouseLeaveDelay: 0.1 },
            React.createElement("span", { dangerouslySetInnerHTML: { __html: escapeHtmlExceptB(senderInfo) } })));
    }
};
export const defaultReceiver = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { data, extraData } = props;
    const email = contactApi.doGetModelDisplayEmail((_a = data === null || data === void 0 ? void 0 : data.sender) === null || _a === void 0 ? void 0 : _a.contact);
    const model = useContactModel({
        contactId: (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.sender) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.id,
        email: email,
        name: (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.sender) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.contact) === null || _g === void 0 ? void 0 : _g.contactName,
    });
    const receivemodel = useContactModel({
        contactId: (_k = (_j = (_h = data === null || data === void 0 ? void 0 : data.receiver[0]) === null || _h === void 0 ? void 0 : _h.contact) === null || _j === void 0 ? void 0 : _j.contact) === null || _k === void 0 ? void 0 : _k.id,
        email: contactApi.doGetModelDisplayEmail((_l = data === null || data === void 0 ? void 0 : data.receiver[0]) === null || _l === void 0 ? void 0 : _l.contact),
        name: (_p = (_o = (_m = data === null || data === void 0 ? void 0 : data.receiver[0]) === null || _m === void 0 ? void 0 : _m.contact) === null || _o === void 0 ? void 0 : _o.contact) === null || _p === void 0 ? void 0 : _p.contactName,
    });
    const preCompanyNames = useMailTabCompanyStr(receivemodel, data === null || data === void 0 ? void 0 : data._account, true);
    const senderInfo = renderContacts(data, { extraData, model, preCompanyNames }) || getIn18Text('WUSHOUJIANREN');
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: escapeHtmlExceptB(senderInfo) } });
};
export const defaultFromFlagAfter = (props) => {
    var _a, _b, _c;
    const { data } = props;
    const { isThread = false, taskId } = data || {};
    const { threadMessageCount } = data.entry || {};
    const { id, displayEmail, accountName } = ((_b = (_a = data === null || data === void 0 ? void 0 : data.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) || {};
    return (React.createElement(React.Fragment, null,
        isThread && threadMessageCount > 1 ? React.createElement("div", { className: "from-count" }, `${threadMessageCount > 99 ? '99+' : threadMessageCount}封`) : React.createElement(React.Fragment, null),
        React.createElement(PersonalMark, { size: 16, contactId: id, email: displayEmail || accountName, canOperate: false, visibleHover: false, noMarkedHidden: true, style: { marginLeft: 4, width: 16, height: 16 } }),
        data.entry.tr_org_ec_info && data.entry.folder != FLOLDER.SENT && data.entry.folder != FLOLDER.DRAFT && ((_c = data.entry.tr_org_ec_info) === null || _c === void 0 ? void 0 : _c.status) == 1 ? (React.createElement("div", { style: { margin: '0 5px', display: 'inline-flex' } },
            React.createElement(Tooltip, { title: data.entry.tr_org_ec_info.name },
                React.createElement(QyTag, null)))) : (React.createElement(React.Fragment, null))));
};
export const defaultComSummaryTask = (props) => {
    const { data } = props;
    const { taskId } = data || {};
    const { total, completed, userType } = data.taskInfo || {};
    return taskId ? (React.createElement("div", { className: "summary-extra-pre-warp" },
        React.createElement("span", { className: "from-task-text" },
            React.createElement(ReadListIcons.TaskMailSvg, null),
            [1, 3, 4, 5, 6, 7].includes(userType) ? `任务${completed}/${total}` : getIn18Text('RENWU')))) : (React.createElement(React.Fragment, null));
};
const setDeadLine = (type, overdue, deadline) => {
    switch (type) {
        case 0:
            return getIn18Text('WUJIEZHISHIJIAN');
            break;
        case 2:
            if (overdue) {
                return (React.createElement("span", { style: { color: '#F74F4F' } },
                    dateFormat('YYYY-mm-dd', deadline * 1000, false),
                    getIn18Text('JIEZHI')));
            }
            else {
                return dateFormat('YYYY-mm-dd', deadline * 1000, false);
            }
            break;
        case 1:
            if (overdue) {
                return (React.createElement("span", { style: { color: '#F74F4F' } },
                    dateFormat('YYYY-mm-dd HH:MM', deadline * 1000, false),
                    getIn18Text('JIEZHI')));
            }
            else {
                return dateFormat('YYYY-mm-dd HH:MM', deadline * 1000, false);
            }
            break;
    }
};
export const defaultTaskDeadLine = (props) => {
    const { data } = props;
    const { taskId } = data || {};
    let { deadline, type, overdue, userType, contactList, executorList } = data.taskInfo || {};
    if (executorList) {
        if (executorList.length <= 6) {
            executorList = cloneDeep(executorList).reverse();
        }
        else {
            executorList = executorList.slice(0, 5).reverse();
        }
    }
    return (React.createElement(React.Fragment, null, taskId && userType != 4 ? (React.createElement(React.Fragment, null, React.createElement(React.Fragment, null,
        React.createElement("span", { className: "progress-time-wrap" }, setDeadLine(type, overdue, deadline)),
        [1, 3, 5, 7].includes(userType) && (React.createElement("div", { style: { marginRight: '6px', marginLeft: '10px' } },
            React.createElement("div", { className: "progress-user" },
                React.createElement("div", { className: "progress-user-item", hidden: executorList.length < 6 },
                    React.createElement("i", null),
                    React.createElement("i", null),
                    React.createElement("i", null)),
                executorList.map(_ => {
                    var _a, _b, _c;
                    const contact = contactList.get(_.accId);
                    if (!contact)
                        return null;
                    return (React.createElement("div", { className: "progress-user-item" },
                        React.createElement(AvatarTag, { size: 20, user: {
                                name: (_a = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _a === void 0 ? void 0 : _a.contactName,
                                avatar: (_b = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _b === void 0 ? void 0 : _b.avatar,
                                color: (_c = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _c === void 0 ? void 0 : _c.color,
                            } })));
                }))))))) : (React.createElement(React.Fragment, null))));
};
export const defaultComTime = (props) => {
    const { data, active } = props;
    const [showConcreteTime] = useState2RM('configMailListShowConcreteTime');
    const { sendTime, isScheduleSend, isDefer, deferTime } = data.entry || {};
    if (isScheduleSend) {
        return (React.createElement("span", { className: "schedule-icon" },
            active ? React.createElement(ReadListIcons.ScheduleSvgCof, { color: "#7D8085" }) : React.createElement(ReadListIcons.ScheduleSvgCof, { color: "#386EE7" }),
            React.createElement("span", { style: { color: active ? '#7D8085' : '#386EE7' } }, formatTimeWithHM(sendTime, false))));
    }
    if (!!isDefer && !!deferTime) {
        if (deferTime === NoSetDeferTime) {
            return React.createElement(React.Fragment, null, getIn18Text('WUCHULISJ'));
        }
        return (React.createElement(React.Fragment, null,
            formatTimeWithHMSimple(deferTime),
            getIn18Text('CHULI1')));
    }
    return React.createElement(React.Fragment, null, showConcreteTime ? formatTimeWithHM(sendTime) : formatDigitalTime(sendTime));
};
export const defaultComSummary = (props) => {
    const { data } = props;
    const { title } = data.entry || {};
    return React.createElement(React.Fragment, null, title ? React.createElement("span", { dangerouslySetInnerHTML: { __html: escapeHtmlExceptB(title) } }) : React.createElement("span", null, getIn18Text('WUZHUTI')));
};
export const defaultCardLongComSummary = (props) => {
    const { data, width } = props;
    const { title } = data.entry || {};
    const widthClassName = useMemo(() => {
        var _a;
        const titleMinWidth = 240;
        if (title && title.length * 12 > titleMinWidth) {
            const warpWidth = width - 463;
            const tagWidth = 62;
            const tagNum = ((_a = data === null || data === void 0 ? void 0 : data.tags) === null || _a === void 0 ? void 0 : _a.length) || 0;
            const tagMrgin = 11;
            const tagsWidth = (tagWidth + tagMrgin) * tagNum;
            return warpWidth - tagsWidth < titleMinWidth ? 'summary-content-maxwidth' : '';
        }
        return 'summary-content-shirnk';
    }, [width, data]);
    return React.createElement(React.Fragment, null, title ? React.createElement("span", { className: `summary-content ${widthClassName}`, dangerouslySetInnerHTML: { __html: title } }) : React.createElement("span", null, getIn18Text('WUZHUTI')));
};
export const defaultComSummaryPreExtra = (props) => {
    const { data, active } = props;
    const { isIcs, praiseId } = data.entry || {};
    return isIcs || praiseId ? (React.createElement("div", { className: "summary-extra-pre-warp" },
        praiseId ? (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "8.00002", cy: "9.33333", r: "5.33333", stroke: "#AA90F4" }),
            React.createElement("circle", { cx: "7.99998", cy: "9.33335", r: "2.66667", stroke: "#AA90F4" }),
            React.createElement("path", { d: "M12.6227 3.41017L13.0568 3.65824L12.6227 3.41017ZM5.10077 5.41858L3.81135 3.1621L2.94311 3.65824L4.23252 5.91472L5.10077 5.41858ZM3.83331 3.24479V1.66665H2.83331V3.24479H3.83331ZM3.66665 1.83331H12.3333V0.833313H3.66665V1.83331ZM12.1666 1.66665V3.24479H13.1666V1.66665H12.1666ZM12.1886 3.1621L10.8992 5.41858L11.7674 5.91472L13.0568 3.65824L12.1886 3.1621ZM12.1666 3.24479C12.1666 3.21579 12.1742 3.18728 12.1886 3.1621L13.0568 3.65824C13.1288 3.53233 13.1666 3.38981 13.1666 3.24479H12.1666ZM12.3333 1.83331C12.2413 1.83331 12.1666 1.75869 12.1666 1.66665H13.1666C13.1666 1.20641 12.7936 0.833313 12.3333 0.833313V1.83331ZM3.83331 1.66665C3.83331 1.75869 3.75869 1.83331 3.66665 1.83331V0.833313C3.20641 0.833313 2.83331 1.20641 2.83331 1.66665H3.83331ZM3.81135 3.1621C3.82574 3.18728 3.83331 3.21579 3.83331 3.24479H2.83331C2.83331 3.38981 2.87116 3.53233 2.94311 3.65824L3.81135 3.1621Z", fill: "#AA90F4" }),
            React.createElement("path", { d: "M6 1V4.33333", stroke: "#AA90F4" }),
            React.createElement("path", { d: "M10 1V4.33333", stroke: "#AA90F4" }))) : (React.createElement(React.Fragment, null)),
        isIcs ? (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.4 3.2V4H5.6V3.2H10.4V4H11.6V3.2H13.3V5.4H2.7V3.2H4.4ZM2.7 6.6V12.8H13.3V6.6H2.7ZM5.6 2H10.4V1H11.6V2H13.7C14.1418 2 14.5 2.35817 14.5 2.8V13.2C14.5 13.6418 14.1418 14 13.7 14H2.3C1.85817 14 1.5 13.6418 1.5 13.2V2.8C1.5 2.35817 1.85817 2 2.3 2H4.4V1H5.6V2Z", fill: "#386EE7" }))) : (React.createElement(React.Fragment, null)))) : null;
};
export const defaultComSummaryExtra = (props) => {
    const { data } = props;
    const { mark } = data.entry || {};
    return React.createElement("div", { className: "red-flag" }, mark === 'redFlag' ? React.createElement(ReadListIcons.RedFlagSvg, null) : '');
};
export const CardOperRedFlag = (props) => {
    const { data, active } = props;
    const { mark } = data.entry || {};
    return (React.createElement("div", { className: "flag" }, mark === 'redFlag' ? (React.createElement(Tooltip, { title: getIn18Text('QUXIAOHONGQI'), mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15 },
        React.createElement("span", { className: "red" },
            React.createElement(ReadListIcons.RedFlagSvg, null)))) : (React.createElement(Tooltip, { title: getIn18Text('BIAOWEIHONGQI'), mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15 },
        React.createElement("span", { className: "grey flag-icon" },
            React.createElement(ReadListIcons.FlagSvg, null))))));
};
export const CardOperFollowUp = (props) => {
    const { data } = props;
    const { isFollowUp } = data.entry || {};
    return (React.createElement("div", { className: "flag" }, isFollowUp ? (React.createElement(Tooltip, { title: getIn18Text('BIAOWEIDAIGJ'), mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15 },
        React.createElement("span", { className: "grey" },
            React.createElement(ReadListIcons.FollowUp, null)))) : (React.createElement(Tooltip, { title: getIn18Text('BIAOWEIYIGJ'), mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15 },
        React.createElement("span", { className: "red" },
            React.createElement(ReadListIcons.UnFollowUp, null))))));
};
export const defaultComStatus = (props) => {
    const { data } = props;
    const { sendStatus } = data.entry || {};
    return sendStatus ? (React.createElement("span", { className: `${sendStatus === 'sending' ? 'sending' : ''}` },
        sendStatus == 'sending' ? getIn18Text('FASONGZHONG..') : '',
        sendStatus == 'sentFailed' ? getIn18Text('YOUJIANFASONGSHI11') : '',
        sendStatus == 'sentNetworkFailed' ? getIn18Text('YOUJIANFASONGSHI12') : '')) : null;
};
export const defaultSuborbinateFrom = (props) => {
    var _a, _b;
    const { data } = props;
    if (((_a = data === null || data === void 0 ? void 0 : data.tpMailInfo) === null || _a === void 0 ? void 0 : _a.subordinateSearch) && ((_b = data.tpMailInfo.receiverSD) === null || _b === void 0 ? void 0 : _b.length)) {
        let str = getIn18Text('LAIYUANXIAS');
        const names = data.tpMailInfo.receiverSD.map(contact => { var _a; return ((_a = contact === null || contact === void 0 ? void 0 : contact.parsed[0]) === null || _a === void 0 ? void 0 : _a.name) || ''; });
        return (React.createElement("span", { style: { color: '#e5a344', display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' } }, str + names.join('、')));
    }
    else {
        return null;
    }
};
export const defaultApprove = (props) => {
    const { data } = props;
    const { entry } = data || {};
    const { approvalStatus } = entry || {};
    if (typeof approvalStatus === 'number') {
        const approveStatusData = approvalStatusMap[approvalStatus];
        if (approveStatusData) {
            const { color, backgroundColor, borderColor, label } = approveStatusData;
            const sty = { color, backgroundColor, borderColor };
            return (React.createElement("div", { className: "approve-status", style: sty }, label));
        }
    }
    return React.createElement(React.Fragment, null);
};
export const defaultSimpleTag = (props) => {
    const { data, hideTagName } = props;
    const { tags, isTpMail } = data || {};
    const _tags = tags === null || tags === void 0 ? void 0 : tags.filter(item => item !== hideTagName);
    const color = _tags === null || _tags === void 0 ? void 0 : _tags.map(tag => mailManagerApi.getTagColor(tag) || '#d9d9d9');
    return color && color.length && !isTpMail ? (React.createElement("span", { style: { marginLeft: '3px', height: '16px' } },
        React.createElement(ReadListIcons.MailTagSvg, { color: color }))) : (React.createElement(React.Fragment, null));
};
export const defaultTag = (props) => {
    const { data, hideTagName } = props;
    const { tags } = data || {};
    const _tags = tags === null || tags === void 0 ? void 0 : tags.filter(item => item !== hideTagName);
    return _tags && _tags.length ? (React.createElement(React.Fragment, null, _tags.map((tag, idx) => {
        return (React.createElement(MailTag, { key: idx, style: { marginRight: idx < _tags.length - 1 ? 4 : 0 }, className: 'com-mail-tag-mini', fontColor: mailManagerApi.getTagFontColor(tag), limit: true, color: mailManagerApi.getTagColor(tag, true) }, transTag2Name(tag)));
    }))) : (React.createElement(React.Fragment, null));
};
export const defaultAllTag = (props) => {
    const { data, hideTagName } = props;
    const { tags } = data || {};
    const _tags = tags === null || tags === void 0 ? void 0 : tags.filter(item => item !== hideTagName);
    return _tags && _tags.length ? (React.createElement("div", { style: { display: 'flex', flex: '1', alignItems: 'center' } }, _tags.map((tag, idx) => {
        return (React.createElement(MailTag, { key: idx, style: { marginLeft: '7px' }, fontColor: mailManagerApi.getTagFontColor(tag), limit: true, color: mailManagerApi.getTagColor(tag, true) }, transTag2Name(tag)));
    }))) : (React.createElement(React.Fragment, null));
};
let stateTrackOpen = null;
const debounceResetStateTrackOpen = debounce(() => (stateTrackOpen = null), 1000);
export const getSiriusStateTrack = () => {
    if (typeof stateTrackOpen === 'boolean') {
        debounceResetStateTrackOpen();
        return stateTrackOpen;
    }
    try {
        const stateTrack = storeApi.getSync('stateTrack').data;
        if (stateTrack === 'OFF') {
            stateTrackOpen = false;
        }
        else {
            stateTrackOpen = true;
        }
        return stateTrackOpen;
    }
    catch (error) {
        console.log('getSiriusStateTrack error', error);
        return true;
    }
};
export const defaultSendReadStatus = (props) => {
    var _a, _b, _c;
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const isCustomerTab = currentTabId === tabId.readCustomer || currentTabType === tabType.customer;
    if (productVersionId === 'free') {
        return null;
    }
    const { data } = props;
    const { authAccountType } = data;
    const { innerCount = 0, rcptCount = 0, innerRead = 0, readCount = 0, openCount = 0, } = data.entry || {};
    if (authAccountType && authAccountType !== '0') {
        const dateArr = (_b = (_a = data.entry.sendTime) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.split(/\s+/);
        const dayLimit = mailManagerApi.getMailDayLimit();
        let isBeforeday = false;
        if (!((_c = data.entry) === null || _c === void 0 ? void 0 : _c.sendTime) || !dateArr || (dateArr === null || dateArr === void 0 ? void 0 : dateArr.length) < 2) {
            isBeforeday = true;
        }
        else {
            const utcStr = dateArr[0] + 'T' + dateArr[1] + '+08:00';
            const sendValue = moment(utcStr);
            if (moment().add(-dayLimit.thirdDayLimit, 'day').isAfter(sendValue, 'day')) {
                isBeforeday = true;
            }
            else {
                isBeforeday = false;
            }
        }
        if (isBeforeday || productVersionId !== 'sirius') {
            return React.createElement(React.Fragment, null);
        }
        else {
            return (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center' }, className: "rs-txt-wrap" },
                React.createElement(IconCard, { type: "tongyong_yuedu" }),
                React.createElement("span", { style: { marginLeft: 4 } }, getIn18Text('DAKAICI', { openCount: openCount || 0 })),
                !!openCount && !isCustomerTab && (React.createElement(Popover, { placement: "rightTop", destroyTooltipOnHide: true, trigger: "hover", mouseEnterDelay: 1, content: React.createElement(OpenRecordsContent, { data: data }) },
                    React.createElement("span", { className: "card-rs-eye" })))));
        }
    }
    let readCont = '';
    if (productVersionId === 'sirius') {
        if (readCount != null && rcptCount != null) {
            const stateTrackOpen = getSiriusStateTrack();
            let [readedCount, unreadCount] = [0, 0];
            if (stateTrackOpen && !isThirdSendFn(data)) {
                readedCount = +readCount;
                unreadCount = +rcptCount - +readCount;
            }
            else {
                readedCount = +innerRead;
                unreadCount = +rcptCount - +innerRead;
            }
            readCont = `${readedCount} ${getIn18Text('YIDU')} · ${unreadCount} ${getIn18Text('WEIDU')} `;
        }
    }
    else {
        if (innerRead != null && rcptCount != null) {
            readCont = `${+innerRead} ${getIn18Text('YIDU')} · ${+rcptCount - +innerRead} ${getIn18Text('WEIDU')} `;
        }
    }
    return (rcptCount || readCount) && readCont ? (React.createElement("span", { className: "rs-txt-wrap" },
        readCont,
        !isCustomerTab && (React.createElement(Popover, { placement: "rightTop", destroyTooltipOnHide: true, trigger: "hover", mouseEnterDelay: 1, content: React.createElement(ReadStatus, { data: data }) },
            React.createElement("span", { className: "card-rs-eye" }))))) : null;
};
export const defaultCustomerLabelAfter = (props) => {
    var _a;
    const { data, isShort = false } = props;
    const { isThread = false, _account } = data || {};
    const { threadMessageCount } = data.entry || {};
    const isSent = useMemo(() => {
        var _a, _b, _c;
        if (data) {
            const accountAlias = ((_b = (_a = systemApi.getCurrentUser(data === null || data === void 0 ? void 0 : data._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
            const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
            const senderEmail = contactApi.doGetModelDisplayEmail((_c = data === null || data === void 0 ? void 0 : data.sender) === null || _c === void 0 ? void 0 : _c.contact);
            return (accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) || accountApi.getIsSameSubAccountSync(senderEmail, data._account));
        }
        else {
            return false;
        }
    }, [data]);
    const marginLeft = isThread && threadMessageCount > 1 ? '-4px' : '4px';
    const style = {
        marginRight: '6px',
        marginLeft,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };
    return isSent ? React.createElement(CustomerLabelAfterCom, Object.assign({}, props)) : React.createElement(CustomerLabel, { style: style, isShort: isShort, contact: (_a = data === null || data === void 0 ? void 0 : data.sender) === null || _a === void 0 ? void 0 : _a.contact, curAccount: _account });
};
const CustomerLabelAfterCom = (props) => {
    var _a;
    const { data, isShort = false } = props;
    const { receiver, _account, isThread = false } = data;
    const { threadMessageCount } = data.entry || {};
    const emails = (_a = receiver === null || receiver === void 0 ? void 0 : receiver.filter(item => item.mailMemberType === 'to')) === null || _a === void 0 ? void 0 : _a.map(item => contactApi.doGetModelDisplayEmail(item.contact));
    const receiversContactModels = useContactModelList(emails, _account);
    const myCustomer = useMemo(() => receiversContactModels.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role) === 'myCustomer'; }), [receiversContactModels]);
    const colleagueCustomer = useMemo(() => receiversContactModels.find(item => { var _a, _b; return ((_a = item === null || item === void 0 ? void 0 : item.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role) === 'colleagueCustomer' || ((_b = item === null || item === void 0 ? void 0 : item.customerOrgModel) === null || _b === void 0 ? void 0 : _b.role) === 'colleagueCustomerNoAuth'; }), [receiversContactModels]);
    const openSeaCustomer = useMemo(() => receiversContactModels.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role) === 'openSeaCustomer'; }), [receiversContactModels]);
    const myClue = useMemo(() => receiversContactModels.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role) === 'myClue'; }), [receiversContactModels]);
    const colleagueClue = useMemo(() => receiversContactModels.find(item => { var _a, _b; return ((_a = item === null || item === void 0 ? void 0 : item.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role) === 'colleagueClue' || ((_b = item === null || item === void 0 ? void 0 : item.customerOrgModel) === null || _b === void 0 ? void 0 : _b.role) === 'colleagueClueNoAuth'; }), [receiversContactModels]);
    const openSeaClue = useMemo(() => receiversContactModels.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role) === 'openSeaClue'; }), [receiversContactModels]);
    const contactModel = useMemo(() => myCustomer || myClue || colleagueCustomer || colleagueClue || openSeaCustomer || openSeaClue || null, [receiversContactModels]);
    const marginLeft = isThread && threadMessageCount > 1 ? '-4px' : '4px';
    const style = {
        marginRight: '6px',
        marginLeft,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };
    return contactModel ? React.createElement(CustomerLabel, { style: style, isShort: isShort, contact: contactModel, curAccount: _account }) : null;
};
